import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	sortByRanking: {
		id: 'issue.views.common.child-issues-panel.heading.ranking.label',
		defaultMessage: 'Sort by rank',
		description: 'Label for a menu option that sorts the issues by rank',
	},
	exceededChildIssuesLimit: {
		id: 'issue.views.common.child-issues-panel.heading.sort-by.exceeded-child-issues-limit',
		defaultMessage: 'To order more than 500 child issues, select ··· > View in search.',
		description: 'Label for sort by rank button tooltip tells users they are over the limit',
	},
	exceededChildIssuesLimitIssueTermRefresh: {
		id: 'issue.views.common.child-issues-panel.heading.sort-by.exceeded-child-issues-limit-issue-term-refresh',
		defaultMessage: 'To order more than 500 child work items, select ··· > View in search.',
		description: 'Label for sort by button rank tooltip tells users they are over the limit',
	},
});
